<template lang="pug">
  div
    header-without-menu
    div.content.access
      div.center-form
        div.text-center
          div: img(src="../../../assets/main_logo_b.png")
          div.mt-4.mb-3(v-html="$t('forgot_desc')")
      b-container(style="max-width:500px")
        b-row
          // 아이디 찾기
          b-col.mt-4(cols="12")
            h4.text-center {{$t('check_n', {v: $t('ID')})}}
            b-card.w-100(no-body)
              b-list-group.list-input(flush)
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="id-badge")
                    b-form-input(
                      type="text",
                      v-model="form.email",
                      :placeholder="$t('ID_email')"
                      @input="isValidEmail")
            b-row.mt-3
              b-col(cols="12")
                b-btn.w-100(@click="idFind") {{$t('find_n', {v: $t('ID')})}}
          // 비밀번호 찾기
          b-col.mt-5(v-if="typeof this.type === 'undefined'" cols="12")
            h4.text-center {{$t('find_n', {v: $t('PW')})}}
            b-card.w-100(no-body)
              b-list-group.list-input(flush)
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="id-card")
                    b-form-input(
                      type="text",
                      v-model="form.mgrid",
                      :placeholder="$t('ID')")
            b-row.mt-3
              b-col.fas-style(cols="12")
                b-btn.w-100(:disabled="sendEmailDisabled", @click="sendEmail") {{$t('password_reset_email_send')}}
                  i.fas.fa-question-circle.fa-lg(@click="HelpSearchPW")
          b-col.mt-5(cols="12")
            b-col.fas-style(cols="12")
            b-btn.w-100(:disabled="sendEmailDisabled", @click="openSupportPage") {{$t('payment_tax_desc1')}}
</template>

<script>
import {findId, resetPW} from '@/api/manage-auth'
import { HeaderWithoutMenu } from '../../mixins/header'
export default {
  name: 'forgot-component',
  components: { HeaderWithoutMenu },
  methods: {
    sendEmail () {
      if (!this.form.mgrid) {
        this.$awn.warning(this.$t('invalid_id'))
        return undefined
      }
      
      let id = this.form.mgrid
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      
      if (reg.test(id)) {
        this.validates.mgrid = true
        this.sendEmailDisabled = true
      } else {
        this.validates.mgrid = false
        this.sendEmailDisabled = false
      }
      let params = {
        lang_code: this.$i18n.locale,
        key: this.form.mgrid,
        type: 'send'
      }
      resetPW(params)
          .then(resp => {
            this.sendEmailDisabled = false
            let {objects} = resp.data
            if (objects.result === 'Success') {
              let params = {
                context: {path: 'password_modify_mail_sent'}
              }
              this.AppState.$emit('show-message-dialog', params)
            } else {
              let params = {
                context: {path: 'not_matched_user'}
              }
              this.AppState.$emit('show-message-dialog', params)
            }
          })
          .catch(err => {
            this.$log.error(err)
            this.sendEmailDisabled = false
          })
    },
    isValidEmail () {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validates.email = reg.test(this.form.email)
    },
    idFind () {
      const vd = this.validates

      if (!this.form.email) {
        this.$awn.warning(this.$t('emile_requirement'))
        return undefined
      }
      if (!vd.email) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'id-invalid'}
        })
        return
      }
      // if (!this.form.phone) {
      //   this.$awn.warning(this.$t('phone_requirement'))
      //   return undefined
      // }
      let params = {
        lang_code: this.$i18n.locale,
        email: this.form.email,
        // phone: this.form.phone
      }
      findId(params)
          .then(resp => {
            let {objects} = resp.data
            let params = {}
            if (objects.result === 'Success') {
              params.context = {path: 'your_email_is', args: {email: objects.email}}
            } else {
              params.context = {path: 'not_matched_user'}
            }
            this.AppState.$emit('show-message-dialog', params)
          })
    },
    HelpSearchPW (e) {
      this.AppState.$emit('show-helpOTP-dialog', { context: {path: 'help_searchPW'} })
      e.stopPropagation()
    },
    openSupportPage () {
      window.open('https://linkmemine.co.kr/request.html')
    }
  },
  mounted() {
    this.type = this.$route.params.type
  },
  data () {
    return {
      sendEmailDisabled: false,
      type: null,
      form: {
        name: '',
        phone: '',
        mgrid: '',
        email: ''
      },
      validates: {
        email: false,
      },
    }
  }
}
</script>

<style lang="scss" scoped src="../access.scss"></style>
<style lang="scss" scoped>
.list-input {
  .list-group-item {
    padding: 4px;
  }
  .form-control {
    border: 0;
    &:focus { box-shadow: none; }
  }
  .input-group-text {
    color: #ccc;
    border: 0;
    background-color: transparent;
    min-width: 46px;
    svg { margin: 0 auto; }
  }
}
.fas-style {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fas {
  z-index: 10;
  cursor: pointer;
  margin-left: 1rem;
}
</style>
